import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: '/home'
    },
    {
      path: '/',
      redirect: '/home'
    },
    {
      path: "",
      name: "center",
      component: () => import("./views/center"),
      children:[
        {
          path: "/home",
          name: "home",
          component: () => import("./views/pages/home"), 
          meta: {
            // keepAlive: true
          }
        },
        {//短期招工
          path: "/shortTerm",
          name: "shortTerm",
          component: () => import("./views/pages/shortTerm"), 
          meta: {
            // keepAlive: true
          }
        },
        {//高薪日结
          path: "/highPay",
          name: "highPay",
          component: () => import("./views/pages/highPay"), 
          meta: {
            // keepAlive: true
          }
        },
        {//周末兼职
          path: "/weekendPart",
          name: "weekendPart",
          component: () => import("./views/pages/weekendPart"), 
          meta: {
            // keepAlive: true
          }
        },
        {//食宿全包
          path: "/inclusive",
          name: "inclusive",
          component: () => import("./views/pages/inclusive"), 
          meta: {
            // keepAlive: true
          }
        },
        {//登录注册
          path: "/login",
          name: "login",
          component: () => import("./views/pages/login"), 
        },
        {//发布信息
          path: "/releaseInfo",
          name: "releaseInfo",
          component: () => import("./views/pages/releaseInfo"), 
          meta: {
            auth: true
          }
        },
        {//个人中心
          path: "/perCenter",
          name: "perCenter",
          component: () => import("./views/pages/perCenter"),
          meta: {
            auth: true
          } 
        },
        {//详情页
          path: "/details",
          name: "details",
          component: () => import("./views/pages/details"), 
          meta: {
            // auth: true
          } 
        },
      ] 
    },
  ],
});

export default router;


router.beforeEach((to,from,next)=>{
  const name=to.name;
  // console.log(to);
  // if (to.meta.auth) { // 判断该路由是否需要登录权限
  //   const token = sessionStorage.getItem('usercode');
  //   if (token) { // 通过vuex state获取当前登录状态
  //     next()
  //   } else {
  //     next(
  //       // 将跳转的路由path作为参数，登录成功后跳转到该路由
  //       {path: '/login'}
  //     )
  //   }}

  if(to.meta.auth){
    const token = sessionStorage.getItem('usercode');
    if(token){
      next();
    }else{
      next(
        // 将跳转的路由path作为参数，登录成功后跳转到该路由
        {path: '/login'}
      )
    }
  }else{
    next();
  }

  // if (to.matched.some(record => record.meta.auth)){
  //   const token = sessionStorage.getItem('usercode');
  //   if(token){
  //     next();
  //   }else {//没有登录信息
  //     if(name == "releaseInfo" || name == "perCenter"){
  //       // next({name: 'login'});
  //       next({path: '/login'})
  //     }
  //     next();
  //   }
  // }
})